import { Box, styled, Typography } from '@mui/material';
import { palette } from '../../theme/palette';
import { HFlex } from '../FlexContainers';
import CrossIcon from '../icons/CrossIcon';

export const StyledModal = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 5px;
  width: 386px;
  max-height: 95vh;
  max-width: 95vw;
  overflow-y: auto;
  :focus-visible {
    outline: 0px;
  }
`;

export const HeaderLabel = styled(Typography)`
  color: ${palette.custom.darkGrey};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.45px;
`;

export const HeaderContainer = styled(HFlex)`
  padding: 9px 24px 9px 24px;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  background: #eee;
`;

export const CloseIcon = styled(CrossIcon)`
  cursor: pointer;
  color: ${palette.custom.grey};
  width: 21px;
  height: 21px;
  object-fit: contain;
`;
